import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBox, FDSecondaryActionIconButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('ChiliPiperComponent', () => ({
  iframe: {
    border: 'none',
    width: '100%',
    height: '100dvh',
  },
}));

const ChiliPiperComponent = ({ rel, handleChiliPiperExit }) => {
  const classes = useStyles();

  return (
    <FDBox flexGrow={1} width="100%">
      {/* Wrapping this in a box with position of absolute because the button needs to be superimposed over the iframe */}
      <Box sx={{
        position: 'absolute',
        padding: '8px',
        right: '0',
      }}
      >
        <FDSecondaryActionIconButton
          icon="close"
          onClick={handleChiliPiperExit}
          {...dataAttrs('chili-piper-iframe-close-button')}
        />
      </Box>
      <iframe
        id="chilipiper"
        title="chilipiper-webview"
        src={rel.link('related').url()}
        className={classes.iframe}
        allow={'fullscreen'}
      />
    </FDBox>
  );
};

ChiliPiperComponent.defaultProps = {
};

ChiliPiperComponent.propTypes = {
  rel: PropTypes.object.isRequired,
  handleChiliPiperExit: PropTypes.func.isRequired,
};

export default ChiliPiperComponent;
